module.exports = __webpack_public_path__ + "logo.987e9486.png";